<template>
    <v-card
            class="mx-auto donationleaderboard"
            max-width="360"
            :dark="isDark"



    >
        <v-tabs

                v-model="tab"
                :color="isDark? 'white':'black'"
                :dark="isDark"
                centered
                grow



        >
            <v-tab


                    v-for="category in categories"
                    :key="category"
            >
                {{ category }}
            </v-tab>
            </v-tabs>
            <v-tabs-items  :dark="isDark" v-model="tab">
            <v-tab-item
                    :dark="isDark"


            >
                <v-list style="padding-bottom:4px;" :dark="isDark" >
                    <v-list-item

                            link
                            v-for="(donation, i) in latest"
                            :key="i"
                            :dark="isDark"
                            :style="{'background':colors[!isDark? 1 : 0][i % 2]}"


                    >


                        <v-chip label
                                :color=colorMe(donation.AMOUNT)
                                class="white--text"
                        >

                            {{donation.SENDER_NAME}}
                            <v-chip
                                    :dark=true

                                    style="background: transparent;font-size:0.8em;padding-left: 10px;opacity: 0.7; margin-right: -8px;"
                            >
                                {{timePassed(donation.TIME_PASSED)}}
                            </v-chip>
                        </v-chip>



                        <v-spacer></v-spacer>
                        <v-chip color="transparent" :ripple="false">{{donation.AMOUNT}} kr</v-chip>
                    </v-list-item>
                </v-list>
            </v-tab-item>

                <v-tab-item
                        :dark="isDark"


                >
                    <v-list :dark="isDark"
                    >
                        <v-list-item
                                v-for="(donation, i) in top48"
                                :key="i"
                                :dark="isDark"
                                :style="{'background':colors[!isDark? 1 : 0][i % 2]}"


                        >
                            <v-chip label
                                    :color=colorMe(donation.AMOUNT)
                                    class="white--text"
                            >
                                {{donation.SENDER_NAME}}
                                <v-chip
                                        :dark=true

                                        style="background: transparent;font-size:0.8em;padding-left: 10px;opacity: 0.7; margin-right: -8px;"
                                >
                                    {{timePassed(donation.TIME_PASSED)}}
                                </v-chip>
                            </v-chip>
                            <v-spacer></v-spacer>
                            <v-chip color="transparent" :ripple="false">{{donation.AMOUNT}} kr</v-chip>
                        </v-list-item>
                    </v-list>
                </v-tab-item>

                <v-tab-item
                        :dark="isDark"


                >
                    <v-list :dark="isDark"
                    >
                        <v-list-item
                                v-for="(donation, i) in top"
                                :key="i"
                                :dark="isDark"
                                :style="{'background':colors[!isDark? 1 : 0][i % 2]}"

                        >
                            <v-chip label
                                    :color=colorMe(donation.AMOUNT)
                                    class="white--text"
                            >
                                {{donation.SENDER_NAME}}
                                <v-chip
                                        :dark=true

                                        style="background: transparent;font-size:0.8em;padding-left: 10px;opacity: 0.7; margin-right: -8px;"
                                >
                                    {{timePassed(donation.TIME_PASSED)}}
                                </v-chip>
                            </v-chip>
                            <v-spacer></v-spacer>
                            <v-chip color="transparent" :ripple="false">{{donation.AMOUNT}} kr</v-chip>
                        </v-list-item>
                    </v-list>
                </v-tab-item>

        </v-tabs-items>


    </v-card>
</template>

<script>
    export default {
        name: "DonationLeaderboard",
        props:["local","isDark"],
        data(){
            return{
                tab:0,
                categories:["Senaste","Topp 48h","Topp"],
                latest:[],
                top48:[],
                top:[],
                colors:[["rgba(45,45,45,0.8)","rgba(36,36,36,0.8)"],["rgba(240,240,240,1)","rgba(250,250,250,1)"]]
            }
        },
        methods:{
            getData(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/leaderboard';

                http.open('GET', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                let self=this;
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        console.log("error");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        let data = JSON.parse(http.response);
                        self.top48=data["48"];
                        self.latest=data["LATEST"];
                        self.top=data["TOP"];
                    }

                };
                http.send();

            },
            getDataLocal(){
                let http = new XMLHttpRequest();
                http.withCredentials = true;
                let url = '/api/leaderboardLocal?';
                let params="path="+window.location.pathname.substring(1);
                if(window.location.pathname.split("/").length>2){
                    params="path="+window.location.pathname.substring(5);
                }

                http.open('POST', url, true);
                http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');

                let self=this;
                http.onreadystatechange = function() {

                    if(http.readyState === 4 && http.status === 403) {

                        console.log("error");

                    }
                    else if(http.readyState === 4 && http.status === 200){
                        let data = JSON.parse(http.response);
                        self.top48=data["48"];
                        self.latest=data["LATEST"];
                        self.top=data["TOP"];
                    }

                };
                http.send(params);

            },
            colorMe(amount){
                if(parseInt(amount)>499){
                    return "orange"
                }
                else if(parseInt(amount)>99){
                    return "purple"
                }
                else if(parseInt(amount)>49){
                    return "blue"
                }
                else if(parseInt(amount)>20){
                    return "green"
                }
                else{
                    return "#3f3f3f"
                }
            },

            timePassed(time){
                if(time>6048000){
                    return "10+ v"
                }
                else if(time>1209600){
                    return `${Math.floor(time/1209600)} w`
                }
                else if(time>1209600){
                    return `${Math.floor(time/1209600)} w`
                }
                else if(time>86400){
                    return `${Math.floor(time/86400)} d`
                }
                else if(time>86400){
                    return `${Math.floor(time/86400)} d`
                }
                else if(time>3600){
                    return `${Math.floor(time/3600)} h`
                }
                else if(time>120){
                    return `${Math.floor(time/60)} m`
                }
                else{
                    return "nu"
                }
            }
        },
        mounted:function(){
            if(this.local){
                this.getDataLocal()
            }
            else{
                this.getData();

            }
        }
    }
</script>

<style scoped>





</style>
